import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountManagerService } from '../service/account-manager.service';

@Injectable({
  providedIn: 'root',
})
export class AccountGuard implements CanActivate {
  private accountManager = inject(AccountManagerService);
  private router = inject(Router);

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.accountManager.isValid()) {
      return true;
    } else {
      this.router.navigateByUrl('init');
    }
  }
}
